import React from 'react';

import './styles/footer.scss';
import Logo from '@components/logo/logo';
import Socials from '@components/socials/socials';

import { t } from '@i18n/i18n';
import footerTranslations from '@i18n/translations/components/footer/footer.json';
import LangA from '../../i18n/LangA';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import useCurrentLanguage from '../../i18n/useCurrentLanguage';
import { relativeSupportEmail } from '../../i18n/environments';
import FooterLanguage from './footer-language.js';

const CustomFooter = ({ onlyLanguage }) => {
  useI18nInitNamespace('customFooter', footerTranslations, true);
  const { isEnIn } = useCurrentLanguage();

  return (
    <footer className="footer">
      <div className="shell-alt">
        {!onlyLanguage && (
          <div className="footer__inner custom__inner">
            <div className="footer__aside custom__aside">
              <Logo id="footer_zb_logo" />

              <div className="copyright">
                <p id="footer_rights_reserved">
                  &copy; {new Date().getFullYear()} ZeroBounce. <br /> {t('p_All_rights_reserved')}
                </p>
              </div>
            </div>
            <div className="footer__content justify-end">
              <div className="footer__contact">
                <h3 className="h6">{t('title_CONTACT_US')}</h3>
                <ul>
                  {isEnIn ? (
                    <>
                      <li>
                        <LangA id="footer_in_contact_1" href="tel:+18779246342">
                          IN: 1-877-924-6342
                        </LangA>
                      </li>
                      <li>
                        <LangA id="footer_in_contact_2" href="tel:+912250972585">
                          IN: +912250972585
                        </LangA>
                      </li>
                    </>
                  ) : (
                    <>
                      <li id="footer_us_contact">
                        {t('li_US')}{' '}
                        <LangA id="footer_us_contact_number" href="tel:+18885009521">
                          1 888 500 9521
                        </LangA>
                      </li>

                      <li id="footer_eu_contact">
                        {t('li_EU')}{' '}
                        <LangA id="footer_eu_contact_number" href="tel:+443308084814">
                          +44 330 808 4814
                        </LangA>
                      </li>
                    </>
                  )}

                  <li id="footer_support_guaranteed">24/7 {t('li_Support_Guaranteed')}</li>

                  <li>
                    <LangA id="footer_mail_to" href={'mailto:' + relativeSupportEmail}>
                      {relativeSupportEmail}
                    </LangA>
                  </li>
                </ul>
                <Socials />
              </div>
            </div>
          </div>
        )}
        <FooterLanguage />
      </div>
    </footer>
  );
};

export default CustomFooter;
